import { Action } from 'redux';
import { ComparePlansHighlightInterface } from './compare-plans-highlight.interface';

const INITIAL_STATE: ComparePlansHighlightInterface = {
  showHighlights: null,
};

const TOGGLE_HIGHLIGHTS = 'TOGGLE_HIGHLIGHTS';


export class ComparePlansHighlightActions implements Action {
  type: string;
  showHighlights?: boolean;
}

export function toggleHighlights(showHighlights: any) {
  return { type: TOGGLE_HIGHLIGHTS, showHighlights };
}

export const COMPARE_PLANS_HIGHLIGHT_REDUCER_NAME = 'ComparePlansHighlight';
export function ComparePlansHighlight(
  state: ComparePlansHighlightInterface = INITIAL_STATE,
  action: ComparePlansHighlightActions
) {
  const copiedState: ComparePlansHighlightInterface = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case TOGGLE_HIGHLIGHTS:
      copiedState.showHighlights = action.showHighlights;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
